module.exports = __webpack_public_path__ + "static/media/Imagen_8.0a1f15db.jpg";